// Shared localized form/error messages for conversion forms.
// Kept small and framework-free so unknown component can import it.

export type FormLang = 'en' | 'tr' | 'nl' | 'fr' | 'ar';

type Dict = Record<FormLang, string>;

const pick = (dict: Dict, lang: string): string =>
  dict[(lang as FormLang)] ?? dict.en;

export const formMessages = {
  verifyRobot: (lang: string) =>
    pick(
      {
        en: 'Please verify that you are not a robot',
        tr: 'Lütfen robot olmadığınızı doğrulayın',
        nl: 'Bevestig dat u geen robot bent',
        fr: 'Veuillez vérifier que vous n’êtes pas un robot',
        ar: 'يرجى التحقق من أنك لست روبوتًا',
      },
      lang,
    ),
  verified: (lang: string) =>
    pick(
      {
        en: 'Verified',
        tr: 'Doğrulandı',
        nl: 'Geverifieerd',
        fr: 'Vérifié',
        ar: 'تم التحقق',
      },
      lang,
    ),
  error: (lang: string) =>
    pick(
      { en: 'Error', tr: 'Hata', nl: 'Fout', fr: 'Erreur', ar: 'خطأ' },
      lang,
    ),
  verificationRequired: (lang: string) =>
    pick(
      {
        en: 'Verification required',
        tr: 'Doğrulama Gerekli',
        nl: 'Verificatie vereist',
        fr: 'Vérification requise',
        ar: 'التحقق مطلوب',
      },
      lang,
    ),
  invalidPhone: (lang: string) =>
    pick(
      {
        en: 'Please enter a valid phone number',
        tr: 'Geçerli bir telefon numarası girin',
        nl: 'Voer een geldig telefoonnummer in',
        fr: 'Veuillez saisir un numéro de téléphone valide',
        ar: 'يرجى إدخال رقم هاتف صالح',
      },
      lang,
    ),
  genericError: (lang: string) =>
    pick(
      {
        en: 'Something went wrong. Please try again.',
        tr: 'Bir hata oluştu. Tekrar deneyin.',
        nl: 'Er is iets misgegaan. Probeer het opnieuw.',
        fr: 'Une erreur est survenue. Veuillez réessayer.',
        ar: 'حدث خطأ. حاول مرة أخرى.',
      },
      lang,
    ),
};
